import { ProductResponse } from "./product.model";
import { WarehouseResponse } from "./warehouse.model";

export class RecurrenceResponse {
	catalogConfig: CatalogConfigResponse[];
	isOk: boolean;
	productList: ProductResponse[];
	recurrenceList: RecurrenceItemResponse[];
	wareHouseList: WarehouseResponse[];
}

export class CatalogConfigResponse {
	billingDate: number;
	description: string;
	endDate: number;
	factId: number;
	id: number;
	isActive: boolean;
	name: string;
	quantityFiles: number;
	recurrence: string;
	startDate: number;
}

export class RecurrenceItemResponse {
	creationDate: number;
	description: string;
	id: number;
	isActive: boolean;
	recurrence: string;
	user: string;
}

export class RecurrenceRequest {
	billingDate: string;
	cashierId: number;
	client: [];
	clients: ClientRecurrenceItem[] = [];
	description: string;
	endDate: string;
	endTime: any;
	factId: number;
	isCashier: boolean;
	isPartial: boolean;
	products: any[] = [];
	recurrence: string;
	startDate: string;
	startTime: any;
	typeClient: any;
	wareHouse: number;
	totalFacts: number = 0;
	unifiedProducts: boolean = true;
	isLimitInvoicePrice: boolean = false;
	limitInvoicePrice: number = 0;
	limitPrice: number = 0;
	idBank: number = 0;
	bankDescription:string = "";
	receiptNumber:string = "";
}

export class ProductRecurrenceItem {
	exemptTextId: number;
	id: number;
	name: string;
	price: number;
	priceEdited: false;
	productDescription: string;
	quantity: number;
	type: string;
	existence?: number;
	costProd?: number;
}

export class ClientRecurrenceItem {
	id: number;
	isNew: boolean;
	numberInvoices: number;
}